import { createContext, FC, PropsWithChildren } from "react";
import { useTrackerIntegration } from "../hooks/useTrackerIntegration";
import { ITrackerIntegrationState } from "../types/tracker-integration";

export const trackerIntegrationContext = createContext<ITrackerIntegrationState>({
    ticketFields: [],
    trackerFieldsLoading: true,
    setComponentList: () => {
    }
});

interface ITrackerIntegrationProviderProps extends PropsWithChildren {
}

export const TrackerIntegrationProvider: FC<ITrackerIntegrationProviderProps> = ({ children }) => {
    const trackerIntegration = useTrackerIntegration();

    return <trackerIntegrationContext.Provider value={trackerIntegration}>
        {children}
    </trackerIntegrationContext.Provider>;
};
